import i18n from "../../i18n";

export type LinkedInRedirect = { ok: true; code: string; state: string } | { ok: false; error: string };

/** What LinkedIn sent this page back with, from its query string, or null when it did not come from LinkedIn. */
export function readLinkedInRedirect(search: string): LinkedInRedirect | null {
  const query = new URLSearchParams(search);
  const code = query.get("code");
  const state = query.get("state");

  if (query.has("error")) return { ok: false, error: i18n.t("login.linkedInCancelled", { ns: "access" }) };
  if (code && state) return { ok: true, code, state };

  return null;
}
